import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table, Button } from 'react-bootstrap';
import {
  SCENARIO_STATUS_ORDER_BY_STATUS,
  SCENARIO_STATE_INFO
} from './../helpers/scenarios.js';

const getRows = (runners, scenarios, goToScenario) => {
  const statusCounter = {
    'FAILED': 0,
    'ERROR': 0,
    'COMPLETED': 0,
    'DISPATCHED': 0,
    'RUNNING': 0,
    'SKIPPED': 0,
    'UNKNOWN': 0,
    'N/A': 0
  };
  if (scenarios)
    return scenarios.map((scenario, i) =>
    {
      const status = scenario.status;
      const scenarioNum = statusCounter[status];
      statusCounter[status] += 1;

      if (scenario.runner && runners.includes(scenario.runner))
      {
        const statusOrder =
          SCENARIO_STATUS_ORDER_BY_STATUS[SCENARIO_STATE_INFO[status].label];
        const position = '' + statusOrder + scenarioNum;
        return (
          <tr key={i}>
            <td>{scenario.name}</td>
            <td>{scenario.status}</td>
            <td style={{ textAlign: 'center' }}>
              <Button onClick={() => goToScenario(position)}>
                Go to scenario
              </Button>
            </td>
          </tr>
        );
      }
    });
  return [];
};

const InstallerTestExpectedModalComponent = ({
  visible,
  runners,
  scenarios,
  onHide,
  goToScenario
}) => (
  <Modal show={visible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>Scenarios</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Table bordered condensed hover className="metrics-table">
        <thead>
          <tr key={'Head'}>
            <th scope="col">Scenario</th>
            <th scope="col">Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {getRows(runners, scenarios, goToScenario)}
        </tbody>
      </Table>
    </Modal.Body>
  </Modal>
);

InstallerTestExpectedModalComponent.propTypes = {
  visible: PropTypes.bool,
  runners: PropTypes.array,
  scenarios: PropTypes.array,
  onHide: PropTypes.func.isRequired,
  goToScenario: PropTypes.func.isRequired
};

export default InstallerTestExpectedModalComponent;


// WEBPACK FOOTER //
// src/Components/InstallerTestScenariosModalComponent.jsx